import React, { useState } from "react"
import { Button, Flex, IconButton } from "@chakra-ui/react"
import { DioboxEvent } from "sharedTypes"
import Popover from "components/dialogs/Popover"
import Icon from "components/elements/Icon"
import MergeFieldInsertIcon from "../MergeFieldInsertIcon"
import MergeFieldInsertPanel from "./MergeFieldInsertPanel"

type Props = {
  event: DioboxEvent
  onInsert: (tagId: string) => void
  draggable?: boolean
  guestFieldsOnly?: boolean
  subjectLineOnly?: boolean
  /** Blue + icon for email subject line; default is legacy SMS "Insert Field" ghost button. */
  iconTrigger?: boolean
}

const MergeFieldInsertPopover = ({
  event,
  onInsert,
  draggable,
  guestFieldsOnly,
  subjectLineOnly,
  iconTrigger = false,
}: Props) => {
  const [isOpen, setIsOpen] = useState(false)

  const trigger = iconTrigger ? (
    <IconButton
      aria-label="Insert merge field"
      icon={<MergeFieldInsertIcon />}
      size="sm"
      w={7}
      h={7}
      minW={7}
      borderRadius="full"
      bg="blue.500"
      color="white"
      _hover={{ bg: "blue.600" }}
      _active={{ bg: "blue.600" }}
    />
  ) : (
    <Button variant="ghost" rightIcon={<Icon icon="down-arrow" fontSize="sm" />} fontSize="sm">
      Insert Field
    </Button>
  )

  return (
    <Flex>
      <Popover
        placement="bottom-start"
        arrow={false}
        isOpen={isOpen}
        onOpen={() => setIsOpen(true)}
        onClose={() => setIsOpen(false)}
        contentWidth={360}
        contentHeight="50vh"
        wrapTrigger={false}
        trigger={trigger}
        body={(
          <MergeFieldInsertPanel
            event={event}
            onInsert={(tagId) => {
              onInsert(tagId)
              setIsOpen(false)
            }}
            onInsertStart={() => setIsOpen(false)}
            draggable={draggable}
            guestFieldsOnly={guestFieldsOnly}
            subjectLineOnly={subjectLineOnly}
          />
        )}
      />
    </Flex>
  )
}

export default MergeFieldInsertPopover
